import { motion } from "framer-motion";

// Maps engine status -> orb visual state
const STATE_STYLES = {
  IDLE: { core: "#D6AE57", glow: "rgba(214,174,87,0.35)", spin: false },
  ANALYZING: { core: "#D6AE57", glow: "rgba(214,174,87,0.45)", spin: true },
  "SETUP FORMING": { core: "#F5B942", glow: "rgba(245,185,66,0.45)", spin: true },
  "WAITING FOR CONFIRMATION": { core: "#F5B942", glow: "rgba(245,185,66,0.4)", spin: true },
  "ENTRY CONDITIONS SATISFIED": { core: "#21C58E", glow: "rgba(33,197,142,0.5)", spin: false },
  WATCH: { core: "#60A5FA", glow: "rgba(96,165,250,0.4)", spin: false },
  "NEWS PROTECTION ACTIVE": { core: "#F5B942", glow: "rgba(245,185,66,0.5)", spin: false },
  "TRADING LOCKED BY YOUR RISK PLAN": { core: "#FF4D67", glow: "rgba(255,77,103,0.5)", spin: false },
  "MARKET DATA STALE": { core: "#FF4D67", glow: "rgba(255,77,103,0.4)", spin: false },
  "NO TRADE": { core: "#667085", glow: "rgba(102,112,133,0.3)", spin: false },
};

export function AurumOrb({ status = "IDLE", size = 96 }) {
  const s = STATE_STYLES[status] || STATE_STYLES.IDLE;
  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }} data-testid="aurum-orb">
      <div className="absolute rounded-full animate-orb-pulse"
        style={{ width: size, height: size, background: `radial-gradient(circle at 40% 35%, ${s.glow}, transparent 70%)`, filter: "blur(6px)" }} />
      {s.spin && (
        <div className="absolute rounded-full animate-orb-spin"
          style={{ width: size * 0.86, height: size * 0.86, border: `2px solid transparent`, borderTopColor: s.core, borderRightColor: s.core, opacity: 0.6 }} />
      )}
      <motion.div
        initial={{ scale: 0.9 }} animate={{ scale: 1 }}
        className="rounded-full"
        style={{
          width: size * 0.5, height: size * 0.5,
          background: `radial-gradient(circle at 35% 30%, #F2D98B, ${s.core} 55%, #07090C 130%)`,
          boxShadow: `0 0 24px ${s.glow}, inset 0 0 12px rgba(255,255,255,0.25)`,
        }}
      />
    </div>
  );
}
